<template>
  <div
    v-if="historyList"
    class="history-module containerScroll"
  >
    <ul
      v-if="changeList.length"
      class="list"
    >
      <li
        v-for="(item, index) in changeList"
        :key="item.id"
        :class="{ 'active': item.active }"
      >
        <div
          class="item clearfix"
          @click="handleDetail(item, index)"
        >
          <div class="top clearfix">
            <span class="addtime">{{ item.addtime }}</span>
            <span class="truename">{{ item.truename }}</span>
            <span
              v-if="item.rolename"
              class="rolename fs-gray"
            >[{{ item.rolename }}]</span>
            <span class="type_desc">{{ item.operate }}</span>
            <template
              v-if="item.userinfo"
              class="userinfo fl"
            >
              <span> ：</span>
              <span v-if="item.userinfo.before">
                {{ item.userinfo.before.truename }}
                <span class="fs-gray">[
                  <i>{{ item.userinfo.before.rolename }}</i>
                  <i v-if="item.userinfo.before.groupname">/{{ item.userinfo.before.groupname }}</i>]
                </span>
              </span>
              <span v-if="item.userinfo.before"> -> </span>
              <span v-if="item.userinfo.after">
                <!-- 离职交接 -->
                <span v-if="item.type === 16">
                  <span>
                    <!-- 0 共享信息 1 具体到人 3 待指派 2 待分配 -->
                    <i v-if="item.userinfo.after.status === 0">{{ $t('message["394"]') }}</i>
                    <span v-else-if="item.userinfo.after.status === 1">
                      <span>{{ item.userinfo.after.truename }}</span>
                    </span>
                    <i v-else-if="item.userinfo.after.status === 2">{{ $t('message["139"]') }}</i>
                    <i v-else-if="item.userinfo.after.status === 3">{{ $t('message["146"]') }}</i>
                    <i v-else-if="item.userinfo.after.status === 5">{{ $t('message["1460"]') }}</i>
                  </span>
                  <span
                    v-if="item.userinfo.after.rolename"
                    class="fs-gray"
                  >[
                    <i>{{ item.userinfo.after.rolename }}</i>
                    <i v-if="item.userinfo.after.groupname">/{{ item.userinfo.after.groupname }}</i>]
                  </span>
                </span>
                <!-- 其他 -->
                <span v-else>
                  <span>{{ item.userinfo.after.truename }}</span>
                  <span class="fs-gray">[
                    <i>{{ item.userinfo.after.rolename }}</i>
                    <i v-if="item.userinfo.after.groupname">/{{ item.userinfo.after.groupname }}</i>]
                  </span>
                </span>
              </span>
              <span v-else>
                {{ item.userinfo.truename }}
                <span class="fs-gray">[
                  <i>{{ item.userinfo.rolename }}</i>
                  <i v-if="item.userinfo.groupname">/{{ item.userinfo.groupname }}</i>]
                </span>
              </span>
            </template>
            <span
              v-if="item.isdetail"
              class="detail-btn btn-text fr"
            >
              {{ $t('message["1316"]') }}
              <i
                v-show="!item.active"
                class="iconfont iconicon-test19 fs-gray"
              />
              <i
                v-show="item.active"
                class="iconfont iconicon-test18 fs-gray"
              />
            </span>
          </div>
          <div
            v-if="item.content"
            class="content"
          >
            {{ item.content }}
          </div>
        </div>
        <change-detail
          v-show="item.active"
          ref="detail"
          :history-detail="historyDetail"
          :detail-loading="detailLoading"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import ChangeDetail from './ChangeDetail'

export default {
  components: {
    ChangeDetail
  },
  data () {
    return {
      // timer: null,
      detailLoading: false
    }
  },
  computed: {
    ...mapState('inquery/detailData', ['historyList', 'historyDetail']),
    inquiryId () {
      return this.$route.params.inquiryId
    },
    changeList () {
      return _.reduce(this.historyList.list, (res, item) => {
        this.$set(item, 'active', false)
        if (item.userinfo) {
          if (item.userinfo.before) {
            for (let k in item.userinfo.before) {
              let key = k.split('_') && k.split('_')[1]
              if (key) {
                item.userinfo.before[key] = item.userinfo.before[k]
              }
            }
          }
          if (item.userinfo.after) {
            for (let k in item.userinfo.after) {
              let key = k.split('_') && k.split('_')[1]
              if (key) {
                item.userinfo.after[key] = item.userinfo.after[k]
              }
            }
          }
          if (!item.userinfo.before && !item.userinfo.after) {
            for (let k in item.userinfo) {
              let key = k.split('_') && k.split('_')[1]
              if (key) {
                item.userinfo[key] = item.userinfo[k]
              }
            }
          }
        }
        res.push(item)
        return res
      }, [])
    }
  },
  async created () {
    await this.getHistoryList()
  },
  /* destroyed () {
    clearTimeout(this.timer)
  }, */
  methods: {
    moment,
    ...mapActions('inquery/detailData', ['fetchHistoryList', 'fetchHistoryDetail']),
    async getHistoryList () {
      const chain = await this.fetchHistoryList()
      chain
        .params({
          inquiryid: this.inquiryId
        })
        .fetch()
    },
    async getHistoryDetail (id, index) {
      this.detailLoading = true
      const chain = await this.fetchHistoryDetail()
      chain
        .params({
          inquiryid: this.inquiryId,
          id
        })
        .onNetSuccess(res => {
          this.detailLoading = false
          /* this.timer = setTimeout(() => {
            this.setValueHeight(index)
          }, 300) */
        })
        .fetch()
    },
    async handleDetail (item, index) {
      if (!item.isdetail) return

      this.changeList.forEach((one) => {
        if (item.id !== one.id) {
          this.$set(one, 'active', false)
        }
      })
      this.$set(item, 'active', !item.active)

      if (item.active) {
        this.getHistoryDetail(item.id, index)
      }
    }
    /* setValueHeight (index) {
      this.$nextTick(() => {
        const detailRef = this.$refs.detail[index]
        for (let i in detailRef.$refs.before) {
          const before = detailRef.$refs.before[i]
          const after = detailRef.$refs.after[i]

          let beforeHeight = before.offsetHeight
          let afterHeight = after.offsetHeight
          if (beforeHeight <= afterHeight) {
            before.style.height = afterHeight + 'px'
            after.style.height = afterHeight + 'px'
          } else {
            before.style.height = beforeHeight + 'px'
            after.style.height = beforeHeight + 'px'
          }
        }
      })
    } */
  }
}
</script>

<style lang="scss" scoped>
.history-module {
  padding: 24px 0 200px;
  i,
  em {
    font-style: normal;
  }
  li:first-child {
    .item {
      border-top: none;
    }
  }
  .item {
    border-top: solid 1px $gray4;
    .top {
      // height: 48px;
      line-height: 24px;
      padding: 12px 0;
      overflow: hidden;
      cursor: pointer;
      & > span:not(.fr) {
        float: left;
      }
    }
    .addtime {
      width: 150px;
      margin-right: 28px;
    }
    .rolename {
      margin: 0 4px;
    }
    .userinfo {
      display: inline-block;
      width: 250px;
    }
    .content {
      padding-bottom: 12px;
      line-height: 24px;
      color: $gray2;
    }
  }
  li.active + li {
    .item {
      border-top: none;
    }
  }
}
</style>
